import React, { useState, useLayoutEffect } from "react";
import useAxios from "axios-hooks";
import classNames from "classnames";
import { useParams } from "react-router-dom";
import { Element, scroller } from "react-scroll";

import Api from "../../api";
import SeoBlock from "../../components/seo_block/SeoBlock";
import {
  Customers,
  Stages,
  ServiceLink,
  Button,
  Spinner
} from "../../components";
import { ProjectExamples } from "../../includes";
import { Section } from "../../layouts";
import { useCorrectCustomers } from "../../hooks";
import { reloadPage } from "../../utils";
import Showreel from "../../components/showreel/Showreel";

import styles from "./styles.module.scss";

const ServiceSingle = ({ contact }) => {
  useLayoutEffect(function redirectToRubyPage() {
    if (!process.env.NODE_ENV || process.env.NODE_ENV === "development") {
      // window.location.replace(`http://localhost:3001${window.location.pathname}`);
    } else {
      window.history.pushState('service_react', '', window.location.pathname);
      //window.history.back();
      reloadPage();
    }
  });

  let service_path = Api.service.replace(
    ":slug",
    window.location.pathname.match(/([^\/]*)\/*$/)[1]
  );

  const [{ data, loading, error }] = useAxios({ url: service_path });
  const correctCustomers = useCorrectCustomers(data?.customers);

  const service = data ? data.service : {};
  const seo = data ? data.seo : {};
  const service_major = data && data.major_service_id;
  const [openFAQ, setOpenFAQ] = useState("");

  const showreel = data && data.showreel && (
    <Showreel showreel={data.showreel} />
  );

  const manager = data && data.manager;

  const sub_services =
    data &&
    data.sub_services.length > 0 &&
    data.sub_services.map((item) => {
      return (
        <ServiceLink
          key={item.id}
          to={`/services/${item.slug}`}
          title={item.title}
          className={styles.serviceSublistItem}
        />
      );
    });

  const contact_in = contact && contact.city_in;
  const h1Title = seo?.seo_h1
    ? seo.seo_h1.includes("#CITY_ROD#")
      ? seo.seo_h1.replace("#CITY_ROD#", contact_in)
      : seo.seo_h1
    : service?.title
    ? `${service.title} ${contact && contact.city_in && ` ${contact.city_in}`}`
    : "";

  const service_faqs =
    data &&
    data.faqs.length > 0 &&
    data.faqs.map((item, index) => {
      return (
        <div
          key={index}
          className={classNames(
            openFAQ === item.id ? "active" : "",
            styles.FAQitem
          )}
          onClick={() => {
            openFAQ === item.id ? setOpenFAQ("") : setOpenFAQ(item.id);
          }}
        >
          <div className={styles.FAQitemFirst}>
            <div className={styles.FAQitemQwe}>{item.question}</div>
            <div
              className={
                openFAQ === item.id
                  ? styles.FAQitemIcoActive
                  : styles.FAQitemIco
              }
            ></div>
          </div>

          <div className={styles.FAQitemSecond}>
            <div
              className={
                openFAQ === item.id
                  ? styles.FAQitemAnswActive
                  : styles.FAQitemAnsw
              }
            >
              {item.answer}
            </div>
          </div>
        </div>
      );
    });

  const handlePriceClick = () => {
    scroller.scrollTo("callback-form", {
      duration: 1500,
      delay: 100,
      smooth: true,
    })
  }

  const service_prices =
    data &&
    data.service_prices.length > 0 &&
    data.service_prices.map((item, index) => {
      return (
        <div key={index} className={styles.serviceCostItem}>
          <div className={styles.serviceCostItemFirst}>
            {item.title}
            <small>{item.sub_title}</small>
          </div>
          <div
            className={styles.serviceCostItemDescr}
            dangerouslySetInnerHTML={{ __html: item.description }}
          />
          <div className={styles.serviceCostItemPrice}>{item.price}</div>

          <Button
            onClick={() => {
              handlePriceClick()
            }}
            className={styles.serviceCostItemButton}
          >
            Отправить заявку
          </Button>
        </div>
      );
    });

  return (
    <div
      className={classNames(
        // "main-container main-container_large-top-indent",
        styles.servicePage
      )}
    >
      <SeoBlock data={seo} contact={contact} />

      <Spinner />

      {/* <div className="wrap holder no-pdn-top">
        {loading && <p>Loading...</p>}
        <div>
          {service && service.title && (
            <h1 className={classNames("h2-title", styles.serviceFirstTitle)}>
              {h1Title}
            </h1>
          )}

          {service && service.description && (
            <h2 className={styles.serviceFirstDescr}>{service.description}</h2>
          )}

          {service && service.image && (
            <div className={styles.serviceFirstImg}>
              <img src={`${request}/${service.image.thumb_long.url}`} alt="" />
            </div>
          )}
        </div>
        {sub_services && (
          <div className={classNames("services-list", styles.serviceSublist)}>
            {sub_services ? sub_services : ""}
          </div>
        )}
      </div>

      <div className="sections-list">
        <div>
          <Section className="section">
            <div className={styles.serviceSecond}>
              <h2 className={styles.SectionTitle}>
                Зачем нужна услуга {service && service.title}
                {contact && contact.city_in && ` ${contact.city_in}`} ?
              </h2>

              {service && service.image_second && service.image_second.thumb_long_second && (
                <div className={styles.serviceSecondImage}>
                  <img
                    src={`${request}/${service.image_second.thumb_long_second.url}`}
                    alt=""
                  />
                </div>
              )}
              <div className={styles.serviceDescrCols}>
                {service && service.info && (
                  <div
                    className={classNames(
                      "new-content",
                      styles.serviceDescrColsItem
                    )}
                    dangerouslySetInnerHTML={{ __html: service.info }}
                  />
                )}
                {service && service.stages_of_creation && (
                  <div
                    className={classNames(
                      "new-content",
                      styles.serviceDescrColsItem
                    )}
                    dangerouslySetInnerHTML={{
                      __html: service.stages_of_creation,
                    }}
                  />
                )}
              </div>
            </div>
          </Section>
        </div>

        {service?.body && (
          <div>
            <Section className="section">
              <div
                className="new-content"
                dangerouslySetInnerHTML={{ __html: service.body }}
              />
            </Section>
          </div>
        )}

        {service?.second_body && (
          <div>
            <Section className="section">
              <div
                className={classNames(
                  "new-content new-content_with-opacity",
                  styles.serviceDescrProposesContent
                )}
                dangerouslySetInnerHTML={{ __html: service.second_body }}
              />
            </Section>
          </div>
        )}

        {service_prices && (
          <div>
            <Section className="section">
              <h2 className={styles.SectionTitle}>
                Сколько стоит {service && service.title}
              </h2>

              {service_prices}
            </Section>
          </div>
        )}

        {service?.after_price_image && (
          <div>
            <Section className="section">
              <div className={styles.afterPrice}>
                <div className={styles.afterPriceInfo}>
                  <h2
                    className={styles.SectionTitle}
                    dangerouslySetInnerHTML={{
                      __html: service.after_price_title,
                    }}
                  />
                  <div
                    className="new-content"
                    dangerouslySetInnerHTML={{
                      __html: service.after_price_text,
                    }}
                  />
                </div>

                <div className={styles.afterPriceImage}>
                  <img
                    src={`${request}/${service.after_price_image.square_thumb.url}`}
                    alt=""
                  />
                </div>
              </div>
            </Section>
          </div>
        )}
      </div>

      <div className="sections-list">
        {data?.service_stages?.length > 0 && (
          <div>
            <Section className="section">
              <Stages
                title="Этапы создания бренда"
                list={data.service_stages}
              />
            </Section>
          </div>
        )}

        {service_faqs && (
          <div>
            <Section className="section">
              <h2 className={styles.SectionTitle}>
                Какие вопросы нам задают чаще всего?
              </h2>

              <div className={styles.FAQ}>{service_faqs}</div>
            </Section>
          </div>
        )}
      </div>

      {showreel}

      <div className="sections-list">
        {correctCustomers?.length > 0 && (
          <div>
            <Section className="section">
              <Customers customers={correctCustomers} />
            </Section>
          </div>
        )}

        {data?.projects.length > 0 && (
          <div>
            <Section className="section">
              <ProjectExamples
                projects={data.projects}
                title={`Мы делаем качественный ${service?.title}. Оцените сами!`}
              />
            </Section>
          </div>
        )}
      </div> */}
    </div>
  );
};

export default ServiceSingle;
